import { Select, Card, Col, Form, Input, Row } from "antd";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import MgmtService from "../../../../app/service/mgmtService";
import { Button } from "../../../../components";
import MgmtLayout from "../../../../components/layouts/MgmtLayout";
import { messageError, messageSuccess } from "../../../../components/toastr";

export const MgmtLoginForm = () => {
    let history = useHistory();
    const mgmtService = new MgmtService();
    const [loading, setLoading] = useState(false);
    const [clients, setClients] = useState([]);

    const { TextArea } = Input;
    
    const submitClient = (data) => {
        setLoading(true);

        mgmtService.createLogin(data).then(res => {
            if (res && res.status === 200) {
                messageSuccess('Login criado com sucesso.');
            } else {
                messageError('Erro ao criar Login');
            }

            setLoading(false);
        }).catch(err => {

            setLoading(false);
        });
    }

    useEffect(() => {
        mgmtService.getClients().then(res => {
            let clients = [];

            res.data.data.forEach(item => {
                clients.push({
                    value: item.clientId, 
                    label: item.name
                });
            });

            setClients(clients);
        }).catch(err => {
            console.log(err);
        });
    }, []);

    return (
        <MgmtLayout>
            <Card title='Cadastro de Login'>
                <Form onFinish={(data) => submitClient(data)} layout="vertical">
                    <Row>
                        <Col xs={24} sm={24} md={12} lg={4} xl={4}>
                            <Form.Item required label={<b style={{ fontSize: '15px', fontWeight: 500 }}>Cliente</b>} name="clientId">
                                <Select
                                    showSearch
                                    filterOption={(input, option) =>
                                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    filterSort={(optionA, optionB) =>
                                        optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())
                                    }
                                    allowClear
                                    placeholder="Selecione um Cliente"
                                    options={clients ? clients : null}
                                    style={{ width: '90%' }}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={4} xl={4}>
                            <Form.Item required label={<b style={{ fontSize: '15px', fontWeight: 500 }}>Usuário</b>} name="username">
                                <Input placeholder='Usuário' name='username' style={{ width: '90%' }} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={4} xl={4}>
                            <Form.Item required label={<b style={{ fontSize: '15px', fontWeight: 500 }}>Senha</b>} name="password">
                                <Input.Password placeholder='Senha' name='password' style={{ width: '90%' }} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                            <Form.Item label={<b style={{ fontSize: '15px', fontWeight: 500 }}>Descrição</b>} name="description">
                                <TextArea placeholder='Descrição' name='description' style={{ width: '90%' }} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                            <Form.Item label={<b style={{ fontSize: '15px', fontWeight: 500 }}>Telegram Chat ID</b>} name="telegramChatid">
                                <Input placeholder='Telegram Chat ID' name='telegram_chatid' style={{ width: '90%' }} />
                            </Form.Item>
                        </Col>

                        <Col style={{ display: 'flex', justifyContent: 'end' }} span={24}>
                            <Button onClick={() => history.goBack()} style={{ marginRight: '10px' }}>Voltar</Button>
                            <Button htmlType='submit' loading={loading} className='successButton'>Salvar</Button>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </MgmtLayout>
    );
}